import React, { FunctionComponent, useState } from "react";

import AuthFlowLayout from "../../layouts/AuthFlowLayout";
import NewPasswordRequiredForm from "./components/NewPasswordRequiredForm";
import SignInForm from "./components/SignInForm";

const SignInPage: FunctionComponent = () => {
  const [isFirstAttempt, setFirstAttempt] = useState<boolean>(false);
  const [authUser, setAuthUser] = useState({});

  return (
    <AuthFlowLayout
      heading="Welcome Back"
      description="Log in: to view your personalized dashboard, campaigns, and audiences."
    >
      {isFirstAttempt ? (
        <NewPasswordRequiredForm authUser={authUser} />
      ) : (
        <SignInForm setFirstAttempt={setFirstAttempt} setAuthUser={setAuthUser} />
      )}
    </AuthFlowLayout>
  );
};

export default SignInPage;
